// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YT3U","newExpiryDate":"styles_newExpiryDate__1ngDf","footer":"styles_footer__13NHD"};